module.exports = __webpack_public_path__ + "img/style4.fce4fe0a.png";